import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import Popper from 'popper.js';
window.Popper = Popper;

import Rails from '@rails/ujs';
window.Rails = Rails;

import './channels';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import('./public/carousel');
import('./public/popup');
import('./public/products');

import { Application } from 'stimulus';
import StimulusReflex from 'stimulus_reflex';
import consumer from './channels/consumer';

const isExternalUrl = (url) => {
  try {
    const parsedUrl = new URL(url, window.location.href);
    return parsedUrl.hostname !== window.location.hostname;
  } catch {
    return false;
  }
};

const addLinkFromFigcaption = () => {
  const URL_REGEX = /url:\s*(\S+)/i;
  const figures = document.querySelectorAll('figure');

  figures.forEach(figure => {
    const figcaption = figure.querySelector('figcaption');
    if (figcaption) {
      let content = figcaption.textContent;
      const urlMatch = content.match(URL_REGEX);
      const img = figure.querySelector('img');

      if (urlMatch && img) {
        const url = urlMatch[1];
        const link = document.createElement('a');

        link.href = url;

        if (isExternalUrl(url)) {
          link.rel = "noopener noreferrer";
          link.target = "_blank";
        }

        img.parentNode.insertBefore(link, img);
        link.appendChild(img);
        figcaption.textContent = content.replace(URL_REGEX, '').trim();
      }
    }
  });
}

Rails.start();

const application = Application.start();

import CartController from "./controllers/public/cart_controller"
application.register("cart", CartController)

import CopyController from "./controllers/public/copy_controller"
application.register("copy", CopyController)

import FeaturedController from "./controllers/public/featured_controller"
application.register("featured", FeaturedController)

import FiltersController from "./controllers/public/filters_controller"
application.register("filters", FiltersController)

import Locker__AuthController from "./controllers/public/locker/auth_controller"
application.register("locker--auth", Locker__AuthController)

import Locker__GiftingController from "./controllers/public/locker/gifting_controller"
application.register("locker--gifting", Locker__GiftingController)

import Locker__OrderController from "./controllers/public/locker/order_controller"
application.register("locker--order", Locker__OrderController)

import Locker__PurchasesController from "./controllers/public/locker/purchases_controller"
application.register("locker--purchases", Locker__PurchasesController)

import OrderController from "./controllers/public/order_controller"
application.register("order", OrderController)

import PagesController from "./controllers/public/pages_controller"
application.register("pages", PagesController)

import ProductController from "./controllers/public/product_controller"
application.register("product", ProductController)

import ProductSortController from "./controllers/public/product_sort_controller"
application.register("product-sort", ProductSortController)

import ProductsController from "./controllers/public/products_controller"
application.register("products", ProductsController)

import SearchController from "./controllers/public/search_controller"
application.register("search", SearchController)

StimulusReflex.initialize(application, { consumer, isolate: true });

// Load dependencies after everything is properly initialized
import('./vendors/jquery.bs5-carousel-swipe');
import('bootstrap-select/dist/js/bootstrap-select.min');

$(function () {
  $('.js-rnb').on('click', function (e) {
    const data = e.currentTarget.dataset;

    if (window.gtag && data) {
      gtag('event', 'banner_click', {
        banner_id: data.bannerId,
        banner_tag: data.bannerTag
      });
    }
  });

  $('.js-lga').on('click', function (e) {
    const gtagData = $(this).data('gtag');

    if (window.gtag && gtagData) {
      gtag('event', gtagData.event, {
        event_category: 'Locker Flow',
        card: gtagData.card,
        merchant: gtagData.merchant
      });
    }
  });

  addLinkFromFigcaption();
});
